import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPageTitle, setSearchEnabled } from "../../../../Redux/Ui/ui.slice";
import parse from "html-react-parser";
import { APIService } from "../../../../Service";
import { EmptyScreen, Loader } from "../../../../Components/Other";

export default function PrivacyPolicy() {
  const dispatch = useDispatch();

  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    dispatch(setPageTitle(["Manage Content"]));
    dispatch(setSearchEnabled(false));

    _getContent();
  }, []);

  const _getContent = async () => {
    try {
      setLoader(true);

      const res = await APIService(false, "content/list", {});

      if (res?.status_code === 200) {
        const list = res?.data || [];
        const privacy = list.find((item) => item.id === 3);

        setData(privacy || null);
      } else {
        setData(null);
      }
    } catch (err) {
      console.error("Content error:", err);
      setData(null);
    } finally {
      setLoader(false);
    }
  };

  if (loader) {
    return <Loader />;
  }
  if (!data) {
    return <EmptyScreen message="Currently No Data Found" />;
  }

  return (
    <div className="d-flex flex-column px-24 pb-24 rg-24">
      {/* Last Updated */}
      <p className="fw-300 mb-0 fs-14 lh-20 text-eerie-black">
        Last updated on : {data?.last_updated_on}
      </p>

      {/* Parsed HTML */}
      <div className="terms_condition_wrapper">{parse(data?.text || "")}</div>
    </div>
  );
}
